var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime-corejs2/core-js/object/define-property", "@babel/runtime-corejs2/core-js/object/define-properties", "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors", "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor", "@babel/runtime-corejs2/core-js/object/get-own-property-symbols", "@babel/runtime-corejs2/core-js/object/keys", "core-js/modules/es6.regexp.to-string", "core-js/modules/es6.date.to-string", "core-js/modules/es6.object.to-string", "@babel/runtime-corejs2/core-js/reflect/construct", "@babel/runtime-corejs2/helpers/extends", "core-js/modules/es6.array.fill", "@babel/runtime-corejs2/core-js/parse-int", "@babel/runtime-corejs2/helpers/toConsumableArray", "@babel/runtime-corejs2/helpers/classCallCheck", "@babel/runtime-corejs2/helpers/createClass", "@babel/runtime-corejs2/helpers/assertThisInitialized", "@babel/runtime-corejs2/helpers/inherits", "@babel/runtime-corejs2/helpers/possibleConstructorReturn", "@babel/runtime-corejs2/helpers/getPrototypeOf", "@babel/runtime-corejs2/helpers/defineProperty", "emotion-theming", "lodash.throttle", "prop-types", "react", "../../../../breakpoints", "../../../../sliderHelpers", "../../themes", "./Arrows", "./GenericTeaser", "./SeekBehaviours", "./SingleLineSlider.css"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime-corejs2/core-js/object/define-property"), require("@babel/runtime-corejs2/core-js/object/define-properties"), require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"), require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"), require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"), require("@babel/runtime-corejs2/core-js/object/keys"), require("core-js/modules/es6.regexp.to-string"), require("core-js/modules/es6.date.to-string"), require("core-js/modules/es6.object.to-string"), require("@babel/runtime-corejs2/core-js/reflect/construct"), require("@babel/runtime-corejs2/helpers/extends"), require("core-js/modules/es6.array.fill"), require("@babel/runtime-corejs2/core-js/parse-int"), require("@babel/runtime-corejs2/helpers/toConsumableArray"), require("@babel/runtime-corejs2/helpers/classCallCheck"), require("@babel/runtime-corejs2/helpers/createClass"), require("@babel/runtime-corejs2/helpers/assertThisInitialized"), require("@babel/runtime-corejs2/helpers/inherits"), require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"), require("@babel/runtime-corejs2/helpers/getPrototypeOf"), require("@babel/runtime-corejs2/helpers/defineProperty"), require("emotion-theming"), require("lodash.throttle"), require("prop-types"), require("react"), require("../../../../breakpoints"), require("../../../../sliderHelpers"), require("../../themes"), require("./Arrows"), require("./GenericTeaser"), require("./SeekBehaviours"), require("./SingleLineSlider.css"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.defineProperties, global.getOwnPropertyDescriptors, global.getOwnPropertyDescriptor, global.getOwnPropertySymbols, global.keys, global.es6Regexp, global.es6Date, global.es6Object, global.construct, global._extends, global.es6Array, global.parseInt, global.toConsumableArray, global.classCallCheck, global.createClass, global.assertThisInitialized, global.inherits, global.possibleConstructorReturn, global.getPrototypeOf, global.defineProperty, global.emotionTheming, global.lodash, global.propTypes, global.react, global.breakpoints, global.sliderHelpers, global.themes, global.Arrows, global.GenericTeaser, global.SeekBehaviours, global.SingleLineSlider);
    global.SingleLineSlider = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _defineProperties, _getOwnPropertyDescriptors, _getOwnPropertyDescriptor, _getOwnPropertySymbols, _keys, _es6Regexp, _es6Date, _es6Object, _construct, _extends2, _es6Array, _parseInt2, _toConsumableArray2, _classCallCheck2, _createClass2, _assertThisInitialized2, _inherits2, _possibleConstructorReturn2, _getPrototypeOf2, _defineProperty3, _emotionTheming, _lodash, _propTypes, _react, _breakpoints, _sliderHelpers, _themes, _Arrows, _GenericTeaser, _SeekBehaviours, _SingleLineSlider) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty2(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _defineProperties = _interopRequireDefault(_defineProperties);
  _getOwnPropertyDescriptors = _interopRequireDefault(_getOwnPropertyDescriptors);
  _getOwnPropertyDescriptor = _interopRequireDefault(_getOwnPropertyDescriptor);
  _getOwnPropertySymbols = _interopRequireDefault(_getOwnPropertySymbols);
  _keys = _interopRequireDefault(_keys);
  _construct = _interopRequireDefault(_construct);
  _extends2 = _interopRequireDefault(_extends2);
  _parseInt2 = _interopRequireDefault(_parseInt2);
  _toConsumableArray2 = _interopRequireDefault(_toConsumableArray2);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _assertThisInitialized2 = _interopRequireDefault(_assertThisInitialized2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _defineProperty3 = _interopRequireDefault(_defineProperty3);
  _lodash = _interopRequireDefault(_lodash);
  _propTypes = _interopRequireDefault(_propTypes);
  _react = _interopRequireDefault(_react);
  _themes = _interopRequireDefault(_themes);
  _GenericTeaser = _interopRequireDefault(_GenericTeaser);

  function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

  var isTouchDevice = function isTouchDevice() {
    return 'ontouchstart' in global && global.innerWidth <= _breakpoints.nextBreakpoints.LARGE;
  };
  /**
   * @callback seekBehaviour
   * @param {Object} parameters
   * @param {number} parameters.index
   * @param {string} parameters.direction - next or prev
   * @param {number} parameters.lastVisibleIndex
   * @param {boolean[]} parameters.visibleSlides
   */


  var SingleLineSlider = /*#__PURE__*/function (_React$PureComponent) {
    (0, _inherits2.default)(SingleLineSlider, _React$PureComponent);

    var _super = _createSuper(SingleLineSlider);

    function SingleLineSlider(props) {
      var _this;

      (0, _classCallCheck2.default)(this, SingleLineSlider);
      _this = _super.call(this, props);
      /**
       * @param {seekBehaviour} _seekBehaviour
       */

      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "onSlideFocus", function (_ref) {
        var index = _ref.index;
        _this._seekBehaviour = _SeekBehaviours.focusBehaviour;
        _this._focusIndex = index;

        if (_this.isFetchMode()) {
          _this.props.fetch();
        } else {
          _this.seek(index);
        }
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "onChangedMediaQueryS", function (media) {
        if (media.matches) {
          _this.onChangedMediaQuery('S');
        }
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "onChangedMediaQueryM", function (media) {
        if (media.matches) {
          _this.onChangedMediaQuery('M');
        }
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "onChangedMediaQueryXL", function (media) {
        if (media.matches) {
          _this.onChangedMediaQuery('XL');
        }
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "onChangedMediaQuery", function (size) {
        _this.isSmallDevice = size === 'S';
        _this.isMediumDevice = size === 'M';
        _this.isXLargeDevice = size === 'XL';

        _this.setState({
          showPrev: false,
          showNext: _this.slides.offsetWidth < _this.slides.scrollWidth,
          index: 0,
          translateX: 0
        });
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "onWindowScroll", function () {
        (0, _sliderHelpers.checkSliderVisibility)(function (_ref2) {
          var visible = _ref2.visible;
          global.removeEventListener('scroll', _this.throttledWindowScroll);

          _this.setState({
            visible: visible
          });
        }, _this.slides);
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "onTouchScroll", function () {
        _this._seekBehaviour = _SeekBehaviours.touchBehaviour;

        if (_this.isFetchMode()) {
          _this.props.fetch();
        }
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "onPrevArrowClick", function () {
        _this._seekBehaviour = _SeekBehaviours.clickBehaviour;

        _this.seek(_this.state.index - 1);
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "onNextArrowClick", function () {
        _this._seekBehaviour = _SeekBehaviours.clickBehaviour;

        if (_this.isFetchMode()) {
          if (!_this.state.fetching) {
            _this.setState({
              fetching: true
            });

            _this.props.fetch();
          }
        } else {
          _this.seek(_this.state.index + 1);
        }
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "getComputedTranslations", function () {
        var slidesWidth = 0;
        return [slidesWidth].concat((0, _toConsumableArray2.default)((0, _toConsumableArray2.default)(_this.slides.querySelectorAll(_SingleLineSlider.StyledSlide)).map(function (el) {
          var slideWidth = (0, _sliderHelpers.getSlideWidth)(el);
          slidesWidth += slideWidth;
          return -slidesWidth;
        })));
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "getDirection", function (currentIndex, nextIndex) {
        return currentIndex <= nextIndex ? 'next' : 'prev';
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "getVisibleSlides", function () {
        var translateX = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var visibleWidth = (0, _parseInt2.default)(global.getComputedStyle(_this.slides).width, 10);
        var slidesWidth = 0;
        return (0, _toConsumableArray2.default)(_this.slides.querySelectorAll(_SingleLineSlider.StyledSlide)).map(function (el) {
          var slideWidth = (0, _sliderHelpers.getSlideWidth)(el);
          slidesWidth += slideWidth;
          var outsideLeftViewport = Math.abs(translateX) > slidesWidth - slideWidth;
          var outsideRightViewport = visibleWidth <= slidesWidth - slideWidth + translateX;
          return !outsideLeftViewport && !outsideRightViewport;
        });
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "isFetchMode", function () {
        return !!_this.props.fetch;
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "slideToActive", function (index) {
        _this._seekBehaviour = _SeekBehaviours.activeIndexBehaviour;

        _this.seek(index, function () {
          var touchDevice = _this.state.touchDevice;

          if (touchDevice) {
            _this.slides.scrollLeft = Math.abs(_this.state.translateX);
          }

          _this._seekBehaviour = touchDevice ? _SeekBehaviours.touchBehaviour : _SeekBehaviours.clickBehaviour;
        });
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "isSliderLargerThanSlides", function () {
        var slidesWidth = (0, _toConsumableArray2.default)(_this.slides.querySelectorAll(_SingleLineSlider.StyledSlide)).map(function (el) {
          return (0, _sliderHelpers.getSlideWidth)(el);
        }).reduce(function (accumulator, current) {
          return accumulator + current;
        }, 0);
        var sliderWidth = _this.slides.offsetWidth;
        return slidesWidth < sliderWidth;
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "seek", function (index, cb) {
        var direction = _this.getDirection(_this.state.index, index);

        var lastVisibleIndex = function lastVisibleIndex() {
          var visibleSlides = _this.getVisibleSlides(_this.state.translateX);

          return visibleSlides.lastIndexOf(true);
        };

        var translations = _this.getComputedTranslations();

        var _this$_seekBehaviour = _this._seekBehaviour({
          index: index,
          direction: direction,
          lastVisibleIndex: lastVisibleIndex
        }),
            getNextIndex = _this$_seekBehaviour.getNextIndex,
            shouldMove = _this$_seekBehaviour.shouldMove;

        var nextIndex = getNextIndex();

        if (shouldMove()) {
          var translateX = translations[nextIndex];
          var showPrev = translateX < 0;

          var showNext = _this.slides.scrollWidth > Math.abs(translateX) + _this.slides.offsetWidth;

          _this.setState({
            showPrev: showPrev,
            showNext: showNext,
            translateX: translateX,
            index: nextIndex,
            visibleSlides: _this.getVisibleSlides(translateX),
            fetching: false
          }, cb);
        }
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "initSlider", function (el) {
        _this.slider = el;
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "initSlides", function (el) {
        _this.slides = el;
      });
      _this._seekBehaviour = _SeekBehaviours.clickBehaviour; // default to mouse

      _this._focusIndex = 0;
      _this.state = {
        index: props.activeIndex === -1 ? 0 : props.activeIndex,
        showPrev: false,
        showNext: true,
        touchDevice: false,
        translateX: 0,
        visible: false,
        // is the slider visible vertically in viewport ?
        visibleSlides: Array(props.teasers.length).fill(false),
        fetching: false
      };
      return _this;
    }

    (0, _createClass2.default)(SingleLineSlider, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this$props = this.props,
            activeIndex = _this$props.activeIndex,
            placeholders = _this$props.placeholders,
            teasers = _this$props.teasers;
        var touchDevice = isTouchDevice();

        if (touchDevice) {
          this._seekBehaviour = _SeekBehaviours.touchBehaviour;
        }

        this.throttledWindowScroll = (0, _lodash.default)(this.onWindowScroll, 500);
        this.throttledTouchScroll = (0, _lodash.default)(this.onTouchScroll, 500);
        this.setState({
          visible: (0, _sliderHelpers.isVisible)(this.slides),
          visibleSlides: this.getVisibleSlides(),
          touchDevice: touchDevice,
          showNext: !this.isSliderLargerThanSlides() // few content

        });

        if (this.slider && !placeholders) {
          this.initEvents();
        }

        if (teasers.length === 0 && this.isFetchMode()) {
          this.props.fetch();
        } else if (activeIndex !== -1 && activeIndex < teasers.length && !this.isFetchMode()) {
          this.slideToActive(activeIndex);
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps, prevState) {
        var _this$props2 = this.props,
            activeIndex = _this$props2.activeIndex,
            teasers = _this$props2.teasers;
        var prevActiveIndex = prevProps.activeIndex,
            prevTeasers = prevProps.teasers;

        if (!prevState.fetching && this.state.fetching) {
          return;
        }

        if (this.isFetchMode() && prevState.visible === false) {
          return;
        }

        if (prevActiveIndex !== activeIndex) {
          this.slideToActive(activeIndex);
        }

        if (prevTeasers.length === teasers.length && this.isFetchMode()) {
          return;
        }

        if (prevTeasers.length > 0 && prevProps.fetch) {
          if (teasers.length > prevTeasers.length) {
            if (this._seekBehaviour.mode === 'focusBehaviour') {
              this.seek(this._focusIndex);
            } else if (this._seekBehaviour.mode === 'clickBehaviour') {
              this.seek(this.state.index + 1);
            }
          } else if (prevState.translateX === this.state.translateX) {
            if (this._seekBehaviour.mode !== 'touchBehaviour') {
              this.seek(this.state.index + 1);
            }
          }
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        global.removeEventListener('scroll', this.throttledWindowScroll);
        this.slides.removeEventListener('scroll', this.throttledTouchScroll);
        this.mediaQueryListS.removeListener(this.onChangedMediaQueryS);
        this.mediaQueryListM.removeListener(this.onChangedMediaQueryM);
        this.mediaQueryListXL.removeListener(this.onChangedMediaQueryXL);
      }
    }, {
      key: "initEvents",
      value: function initEvents() {
        global.addEventListener('scroll', this.throttledWindowScroll);
        this.slides.addEventListener('scroll', this.throttledTouchScroll);
        this.mediaQueryListS = global.matchMedia('(max-width: 767px)');
        this.mediaQueryListM = global.matchMedia('(min-width: 768px) and (max-width: 1199px)');
        this.mediaQueryListXL = global.matchMedia('(min-width: 1200px)');
        this.mediaQueryListS.addListener(this.onChangedMediaQueryS);
        this.mediaQueryListM.addListener(this.onChangedMediaQueryM);
        this.mediaQueryListXL.addListener(this.onChangedMediaQueryXL);
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props3 = this.props,
            kind = _this$props3.kind,
            placeholders = _this$props3.placeholders,
            teasers = _this$props3.teasers,
            theme = _this$props3.theme,
            themeName = _this$props3.themeName;
        var _this$state = this.state,
            showNext = _this$state.showNext,
            showPrev = _this$state.showPrev,
            touchDevice = _this$state.touchDevice,
            translateX = _this$state.translateX,
            visible = _this$state.visible; // manage slider arrows

        var nextArrowClass = !showNext || !visible ? 'invisible' : '';
        var prevArrowClass = !showPrev || !visible ? 'invisible' : '';
        var needPlaceholders = this.isFetchMode() && teasers.length === 0 || !this.isFetchMode() && placeholders > 0;
        var teaserList = needPlaceholders ? Array(10).fill(true).map(function (value, index) {
          return {
            placeholder: value,
            id: "".concat(index),
            images: []
          };
        }) : teasers;
        var translateStyle = touchDevice ? {} : {
          transform: "translate3d(".concat(translateX, "px, 0, 0)")
        };
        return /*#__PURE__*/_react.default.createElement(_emotionTheming.ThemeProvider, {
          theme: _themes.default[theme]
        }, /*#__PURE__*/_react.default.createElement(_SingleLineSlider.StyledSlider, {
          _kind: kind,
          themeName: theme
        }, /*#__PURE__*/_react.default.createElement(_Arrows.PrevArrow, {
          theme: theme,
          color: _themes.default[theme].singleLineSlider.arrowFillColor,
          size: _themes.default[theme].singleLineSlider.arrowSizes,
          onClick: this.onPrevArrowClick,
          stateClass: prevArrowClass,
          touchDevice: touchDevice
        }), /*#__PURE__*/_react.default.createElement(_SingleLineSlider.StyledWrapper, {
          ref: this.initSlider
        }, /*#__PURE__*/_react.default.createElement(_SingleLineSlider.StyledSlides, {
          ref: this.initSlides,
          style: translateStyle,
          touchDevice: touchDevice
        }, teaserList.map(function (teaser, teaserIndex) {
          return /*#__PURE__*/_react.default.createElement(_GenericTeaser.default, (0, _extends2.default)({}, _objectSpread(_objectSpread({}, _this2.props), _this2.state), {
            teaser: teaser,
            index: teaserIndex,
            onSlideFocus: _this2.onSlideFocus,
            key: "".concat(teaser.title, "-").concat(teaserIndex),
            themeName: themeName || theme,
            theme: _themes.default[theme],
            withoutTitle: kind === 'LANDSCAPE_NOLABEL'
          }));
        }))), /*#__PURE__*/_react.default.createElement(_Arrows.NextArrow, {
          theme: theme,
          color: _themes.default[theme].singleLineSlider.arrowFillColor,
          size: _themes.default[theme].singleLineSlider.arrowSizes,
          onClick: this.onNextArrowClick,
          stateClass: nextArrowClass,
          touchDevice: touchDevice,
          loading: this.state.fetching
        })));
      }
    }]);
    return SingleLineSlider;
  }(_react.default.PureComponent);

  SingleLineSlider.propTypes = {
    activeIndex: _propTypes.default.number,
    fetch: _propTypes.default.func,
    kind: _propTypes.default.string,
    onTeaserClick: _propTypes.default.func,
    placeholders: _propTypes.default.number,
    teasers: _propTypes.default.arrayOf(_propTypes.default.shape()).isRequired,
    theme: _propTypes.default.string,
    themeName: _propTypes.default.string
  };
  SingleLineSlider.defaultProps = {
    activeIndex: -1,
    kind: '',
    onTeaserClick: function onTeaserClick(event, index) {},
    placeholders: 0,
    teasers: [],
    theme: 'next',
    themeName: ''
  };
  var _default = SingleLineSlider;
  _exports.default = _default;
});